import React from 'react';
import UploadModal from './../../../common/UploadModal'
import Resource from '../../../common/Resource'
import Panel from '../../../common/layout/Panel'

export default class extends React.Component {
    render () {
        const data = {
            url: '/admin/routing/sms/srcnumbers',
            data: {
                data: [],
                metadata: []
            },
            metadata:
                [
                    {
                        'label': 'id',
                        'source': 'ATRSMSROUTINGSRCNUMBERID',
                        'type': 'primary',
                        'editable': false,
                        'visible': false
                    },
                    {
                        'label': 'Source Number',
                        'source': 'ATRNUMBER',
                        'type': 'text',
                        'editable': true,
                        'visible': true,
                        'placeholder': 'New Source number pattern...'
                    },
                    {
                        'label': 'Enabled',
                        'source': 'ATRENABLED',
                        'type': 'checkbox',
                        'editable': true,
                        'visible': true,
                        'default' : true
                    },
                    {
                        'label' : 'Actions',
                        'type': 'action_buttons'
                    }
                ]
        }
        return (
            <Panel title = "SMS Source Number Patterns">
                <Resource
                    addButtonText = "Add SMS Source Number Pattern"                    
                    data = {data}
                    {...this.props} 
                    pagination
                />
            </Panel>
        )
    }
}
   